export { default } from './badges.js';
